export const WORDS = [
  'AGENT',
  'WORLD',
  'ABOUT',
  'HEART',
  'WATER',
  'SIXTY',
  'BOARD',
  'MONTH',
  'MUSIC',
  'PARTY',
  'PIANO',
  'MOUTH',
  'WOMAN',
  'SUGAR',
  'AMBER',
  'DREAM',
  'LAUGH',
  'TIGER',
  'EARTH',
  'MONEY',
  'WORDS',
  'SMILE',
  'LEMON',
  'SOUTH',
  'AFTER',
  'STONE',
  'THING',
  'LIGHT',
  'STORY',
  'POWER',
  'TODAY',
  'RANGE',
  'PEARL',
  'VENOM',
  'PROXY',
  'ROUND',
  'HOVER',
  'CANDY',
  'ABOVE',
  'PHONE',
  'OTHER',
  'SMART',
  'BLACK',
  'MAGIC',
  'FRUIT',
  'RADIO',
  'ROYAL',
  'HONEY',
  'FLAKE',
  'SOUND', 
  'CHAIR',
  'FROST',
  'DANCE',
  'BRAIN',
  'PLANT',
  'CLOUD',
  'BERRY',
  'CHAOS',
  'QUEST',
  'PULSE',
  'GLASS',
  'GREEN',
  'GRACE',
  'JOKER',
  'FROGS',
  'FLUTE',
  'PENNY',
  'QUICK',
  'SLEEP',
  'GHOST',
  'MARCH',
  'RIVER',
  'SHEEP',
  'BEACH',
  'TOWER',
  'TRUTH',
  'FOLKS',
  'SPELL',
  'SWING',
  'SCENT',
  'SPACE',
  'PLUTO',
  'BLISS',
  'PAINT',
  'SUNNY',
  'JAZZY',
  'IVORY',
  'CLOCK',
  'SKYLY',
  'SHINE',
  'GLOWY',
  'CROWN',
  'QUEEN',
  'BRUSH',
  'FLUFF',
  'FAITH',
  'LUCKY',
  'STORM',
  'STARS',
];
